module.exports = __webpack_public_path__ + "assets/devices/KF-234-PG2-bc6ad37af5cb54e1cea9d950a85aaa3f.svg";